import type { GuidedNbaItem } from './types'
import type { ModuleCarouselFragment } from '../../modules/Carousel/__generated__/fragment'
import type { ModuleCarousel } from '../../types'
import type { FacetTileCarousel } from '../../pages/GalleryPage/types'

type ModuleFacetTileItem = Extract<
  ModuleCarouselFragment['items'][number],
  { __typename: 'ModuleFacetTile' }
>

const isModuleFacetTileItem = (
  item: ModuleCarouselFragment['items'][number],
): item is ModuleFacetTileItem => item.__typename === 'ModuleFacetTile'

const mapFacetTileItem = (item: ModuleFacetTileItem): GuidedNbaItem => ({
  facetDetails:
    item.facetDetails
      ?.map(facet => facet.key)
      .filter((key): key is string => Boolean(key)) ?? [],
  tile: {
    title: item.tile.title,
    url: item.tile.url,
    image: {
      url: item.tile.image.webpUrl || item.tile.image.defaultUrl,
    },
  },
})

export const mapFacetTileCarousel = (
  module: ModuleCarousel,
): FacetTileCarousel => ({
  title: module.title,
  items: module.items.filter(isModuleFacetTileItem).map(mapFacetTileItem),
})
